// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/nucleo.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/nucleo.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/nucleo.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/nucleo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --------------------------------

Nucleo Outline Web Font - nucleoapp.com/
License - nucleoapp.com/license/
Created using IcoMoon - icomoon.io

-------------------------------- */

@font-face {
  font-family: 'Nucleo';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

/*------------------------
	base class definition
-------------------------*/

.tim-icons {
  display: inline-block;
  font: normal normal normal 1em/1 'Nucleo';
  vertical-align: middle;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.font-icon-detail {
  text-align: center;
  padding: 45px 0 30px;
  border: 1px solid #e44cc4;
  border-radius: .1875rem;
  margin: 15px 0;
  min-height: 168px;
}

.font-icon-detail i {
  color: #FFFFFF;
  font-size: 1.5em;
}

.font-icon-detail p {
  color: #e44cc4 !important;
  margin-top: 30px;
  padding: 0 10px;
  font-size: .7142em;
}

/*------------------------
  change icon size
-------------------------*/

.tim-icons-sm {
  font-size: 0.8em;
}

.tim-icons-lg {
  font-size: 1.2em;
}

/* absolute units */

.tim-icons-16 {
  font-size: 16px;
}

.tim-icons-32 {
  font-size: 32px;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/

.tim-icons-bg-square,
.tim-icons-bg-circle {
  padding: 0.35em;
}

.tim-icons-bg-circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/

/*------------------------
  spinning icons
-------------------------*/

.tim-icons-is-spinning {
  animation: tim-icons-spin 2s infinite linear;
}

@keyframes tim-icons-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*------------------------
  rotated/flipped icons
-------------------------*/

/*------------------------
	icons
-------------------------*/

.icon-alert-circle-exc::before {
  content: "\\ea02";
}

.icon-align-center::before {
  content: "\\ea03";
}

.icon-align-left-2::before {
  content: "\\ea04";
}

.icon-app::before {
  content: "\\ea05";
}

.icon-atom::before {
  content: "\\ea06";
}

.icon-attach-87::before {
  content: "\\ea07";
}

.icon-badge::before {
  content: "\\ea08";
}

.icon-bag-16::before {
  content: "\\ea09";
}

.icon-bank::before {
  content: "\\ea0a";
}

.icon-basket-simple::before {
  content: "\\ea0b";
}

.icon-bell-55::before {
  content: "\\ea0c";
}

.icon-bold::before {
  content: "\\ea0d";
}

.icon-book-bookmark::before {
  content: "\\ea0e";
}

.icon-bulb-63::before {
  content: "\\ea0f";
}

.icon-bullet-list-67::before {
  content: "\\ea10";
}

.icon-bus-front-12::before {
  content: "\\ea11";
}

.icon-button-pause::before {
  content: "\\ea12";
}

.icon-button-power::before {
  content: "\\ea13";
}

.icon-calendar-60::before {
  content: "\\ea14";
}

.icon-camera-18::before {
  content: "\\ea15";
}

.icon-caps-small::before {
  content: "\\ea16";
}

.icon-cart::before {
  content: "\\ea17";
}

.icon-chart-bar-32::before {
  content: "\\ea18";
}

.icon-chart-pie-36::before {
  content: "\\ea19";
}

.icon-chat-33::before {
  content: "\\ea1a";
}

.icon-check-2::before {
  content: "\\ea1b";
}

.icon-cloud-download-93::before {
  content: "\\ea1c";
}

.icon-cloud-upload-94::before {
  content: "\\ea1d";
}

.icon-coins::before {
  content: "\\ea1e";
}

.icon-compass-05::before {
  content: "\\ea1f";
}

.icon-controller::before {
  content: "\\ea20";
}

.icon-credit-card::before {
  content: "\\ea21";
}

.icon-delivery-fast::before {
  content: "\\ea22";
}

.icon-double-left::before {
  content: "\\ea23";
}

.icon-double-right::before {
  content: "\\ea24";
}

.icon-email-85::before {
  content: "\\ea25";
}

.icon-gift-2::before {
  content: "\\ea26";
}

.icon-globe-2::before {
  content: "\\ea27";
}

.icon-headphones::before {
  content: "\\ea28";
}

.icon-heart-2::before {
  content: "\\ea29";
}

.icon-html5::before {
  content: "\\ea2a";
}

.icon-image-02::before {
  content: "\\ea2b";
}

.icon-istanbul::before {
  content: "\\ea2c";
}

.icon-key-25::before {
  content: "\\ea2d";
}

.icon-laptop::before {
  content: "\\ea2e";
}

.icon-light-3::before {
  content: "\\ea2f";
}

.icon-link-72::before {
  content: "\\ea30";
}

.icon-lock-circle::before {
  content: "\\ea31";
}

.icon-map-big::before {
  content: "\\ea32";
}

.icon-minimal-down::before {
  content: "\\ea33";
}

.icon-minimal-left::before {
  content: "\\ea34";
}

.icon-minimal-right::before {
  content: "\\ea35";
}

.icon-minimal-up::before {
  content: "\\ea36";
}

.icon-mobile::before {
  content: "\\ea37";
}

.icon-molecule-40::before {
  content: "\\ea38";
}

.icon-money-coins::before {
  content: "\\ea39";
}

.icon-notes::before {
  content: "\\ea3a";
}

.icon-palette::before {
  content: "\\ea3b";
}

.icon-paper::before {
  content: "\\ea3c";
}

.icon-pencil::before {
  content: "\\ea3d";
}

.icon-pin::before {
  content: "\\ea3e";
}

.icon-planet::before {
  content: "\\ea3f";
}

.icon-puzzle-10::before {
  content: "\\ea40";
}

.icon-satisfied::before {
  content: "\\ea41";
}

.icon-scissors::before {
  content: "\\ea42";
}

.icon-send::before {
  content: "\\ea43";
}

.icon-settings-gear-63::before {
  content: "\\ea44";
}

.icon-settings::before {
  content: "\\ea45";
}

.icon-simple-add::before {
  content: "\\ea46";
}

.icon-simple-delete::before {
  content: "\\ea47";
}

.icon-simple-remove::before {
  content: "\\ea48";
}

.icon-single-02::before {
  content: "\\ea49";
}

.icon-single-copy-04::before {
  content: "\\ea4a";
}

.icon-sound-wave::before {
  content: "\\ea4b";
}

.icon-spaceship::before {
  content: "\\ea4c";
}

.icon-square-pin::before {
  content: "\\ea4d";
}

.icon-support-17::before {
  content: "\\ea4e";
}

.icon-tablet-2::before {
  content: "\\ea4f";
}

.icon-tag::before {
  content: "\\ea50";
}

.icon-tap-02::before {
  content: "\\ea51";
}

.icon-tie-bow::before {
  content: "\\ea52";
}

.icon-time-alarm::before {
  content: "\\ea53";
}

.icon-trash-simple::before {
  content: "\\ea54";
}

.icon-triangle-right-17::before {
  content: "\\ea55";
}

.icon-trophy::before {
  content: "\\ea56";
}

.icon-tv-2::before {
  content: "\\ea57";
}

.icon-upload::before {
  content: "\\ea58";
}

.icon-user-run::before {
  content: "\\ea59";
}

.icon-vector::before {
  content: "\\ea5a";
}

.icon-video-66::before {
  content: "\\ea5b";
}

.icon-volume-98::before {
  content: "\\ea5c";
}

.icon-wallet-43::before {
  content: "\\ea5d";
}

.icon-watch-time::before {
  content: "\\ea5e";
}

.icon-wifi::before {
  content: "\\ea5f";
}

.icon-world::before {
  content: "\\ea60";
}

.icon-zoom-split::before {
  content: "\\ea61";
}

.icon-refresh-01::before {
  content: "\\ea62";
}

.icon-refresh-02::before {
  content: "\\ea63";
}

.icon-shape-star::before {
  content: "\\ea64";
}

.icon-components::before {
  content: "\\ea65";
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/nucleo-icons.css"],"names":[],"mappings":"AAAA;;;;;;kCAMkC;;AAElC;EACE,qBAAqB;EACrB,4CAA+B;EAC/B,qPAAoM;EACpM,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;EACE,qBAAqB;EACrB,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;oCAEoC;;AAEpC;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;0BAE0B;;AAE1B;;0BAE0B;;AAE1B;EAGE,4CAA4C;AAC9C;;AAoBA;EACE;IAKE,uBAAuB;EACzB;EACA;IAKE,yBAAyB;EAC3B;AACF;;AAEA;;0BAE0B;;AAE1B;;0BAE0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* --------------------------------\r\n\r\nNucleo Outline Web Font - nucleoapp.com/\r\nLicense - nucleoapp.com/license/\r\nCreated using IcoMoon - icomoon.io\r\n\r\n-------------------------------- */\r\n\r\n@font-face {\r\n  font-family: 'Nucleo';\r\n  src: url('../fonts/nucleo.eot');\r\n  src: url('../fonts/nucleo.eot') format('embedded-opentype'), url('../fonts/nucleo.woff2') format('woff2'), url('../fonts/nucleo.woff') format('woff'), url('../fonts/nucleo.ttf') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n/*------------------------\r\n\tbase class definition\r\n-------------------------*/\r\n\r\n.tim-icons {\r\n  display: inline-block;\r\n  font: normal normal normal 1em/1 'Nucleo';\r\n  vertical-align: middle;\r\n  speak: none;\r\n  text-transform: none;\r\n  /* Better Font Rendering */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.font-icon-detail {\r\n  text-align: center;\r\n  padding: 45px 0 30px;\r\n  border: 1px solid #e44cc4;\r\n  border-radius: .1875rem;\r\n  margin: 15px 0;\r\n  min-height: 168px;\r\n}\r\n\r\n.font-icon-detail i {\r\n  color: #FFFFFF;\r\n  font-size: 1.5em;\r\n}\r\n\r\n.font-icon-detail p {\r\n  color: #e44cc4 !important;\r\n  margin-top: 30px;\r\n  padding: 0 10px;\r\n  font-size: .7142em;\r\n}\r\n\r\n/*------------------------\r\n  change icon size\r\n-------------------------*/\r\n\r\n.tim-icons-sm {\r\n  font-size: 0.8em;\r\n}\r\n\r\n.tim-icons-lg {\r\n  font-size: 1.2em;\r\n}\r\n\r\n/* absolute units */\r\n\r\n.tim-icons-16 {\r\n  font-size: 16px;\r\n}\r\n\r\n.tim-icons-32 {\r\n  font-size: 32px;\r\n}\r\n\r\n/*----------------------------------\r\n  add a square/circle background\r\n-----------------------------------*/\r\n\r\n.tim-icons-bg-square,\r\n.tim-icons-bg-circle {\r\n  padding: 0.35em;\r\n}\r\n\r\n.tim-icons-bg-circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n/*------------------------\r\n  list icons\r\n-------------------------*/\r\n\r\n/*------------------------\r\n  spinning icons\r\n-------------------------*/\r\n\r\n.tim-icons-is-spinning {\r\n  -webkit-animation: tim-icons-spin 2s infinite linear;\r\n  -moz-animation: tim-icons-spin 2s infinite linear;\r\n  animation: tim-icons-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes tim-icons-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@-moz-keyframes tim-icons-spin {\r\n  0% {\r\n    -moz-transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -moz-transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes tim-icons-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    -moz-transform: rotate(0deg);\r\n    -ms-transform: rotate(0deg);\r\n    -o-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    -moz-transform: rotate(360deg);\r\n    -ms-transform: rotate(360deg);\r\n    -o-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/*------------------------\r\n  rotated/flipped icons\r\n-------------------------*/\r\n\r\n/*------------------------\r\n\ticons\r\n-------------------------*/\r\n\r\n.icon-alert-circle-exc::before {\r\n  content: \"\\ea02\";\r\n}\r\n\r\n.icon-align-center::before {\r\n  content: \"\\ea03\";\r\n}\r\n\r\n.icon-align-left-2::before {\r\n  content: \"\\ea04\";\r\n}\r\n\r\n.icon-app::before {\r\n  content: \"\\ea05\";\r\n}\r\n\r\n.icon-atom::before {\r\n  content: \"\\ea06\";\r\n}\r\n\r\n.icon-attach-87::before {\r\n  content: \"\\ea07\";\r\n}\r\n\r\n.icon-badge::before {\r\n  content: \"\\ea08\";\r\n}\r\n\r\n.icon-bag-16::before {\r\n  content: \"\\ea09\";\r\n}\r\n\r\n.icon-bank::before {\r\n  content: \"\\ea0a\";\r\n}\r\n\r\n.icon-basket-simple::before {\r\n  content: \"\\ea0b\";\r\n}\r\n\r\n.icon-bell-55::before {\r\n  content: \"\\ea0c\";\r\n}\r\n\r\n.icon-bold::before {\r\n  content: \"\\ea0d\";\r\n}\r\n\r\n.icon-book-bookmark::before {\r\n  content: \"\\ea0e\";\r\n}\r\n\r\n.icon-bulb-63::before {\r\n  content: \"\\ea0f\";\r\n}\r\n\r\n.icon-bullet-list-67::before {\r\n  content: \"\\ea10\";\r\n}\r\n\r\n.icon-bus-front-12::before {\r\n  content: \"\\ea11\";\r\n}\r\n\r\n.icon-button-pause::before {\r\n  content: \"\\ea12\";\r\n}\r\n\r\n.icon-button-power::before {\r\n  content: \"\\ea13\";\r\n}\r\n\r\n.icon-calendar-60::before {\r\n  content: \"\\ea14\";\r\n}\r\n\r\n.icon-camera-18::before {\r\n  content: \"\\ea15\";\r\n}\r\n\r\n.icon-caps-small::before {\r\n  content: \"\\ea16\";\r\n}\r\n\r\n.icon-cart::before {\r\n  content: \"\\ea17\";\r\n}\r\n\r\n.icon-chart-bar-32::before {\r\n  content: \"\\ea18\";\r\n}\r\n\r\n.icon-chart-pie-36::before {\r\n  content: \"\\ea19\";\r\n}\r\n\r\n.icon-chat-33::before {\r\n  content: \"\\ea1a\";\r\n}\r\n\r\n.icon-check-2::before {\r\n  content: \"\\ea1b\";\r\n}\r\n\r\n.icon-cloud-download-93::before {\r\n  content: \"\\ea1c\";\r\n}\r\n\r\n.icon-cloud-upload-94::before {\r\n  content: \"\\ea1d\";\r\n}\r\n\r\n.icon-coins::before {\r\n  content: \"\\ea1e\";\r\n}\r\n\r\n.icon-compass-05::before {\r\n  content: \"\\ea1f\";\r\n}\r\n\r\n.icon-controller::before {\r\n  content: \"\\ea20\";\r\n}\r\n\r\n.icon-credit-card::before {\r\n  content: \"\\ea21\";\r\n}\r\n\r\n.icon-delivery-fast::before {\r\n  content: \"\\ea22\";\r\n}\r\n\r\n.icon-double-left::before {\r\n  content: \"\\ea23\";\r\n}\r\n\r\n.icon-double-right::before {\r\n  content: \"\\ea24\";\r\n}\r\n\r\n.icon-email-85::before {\r\n  content: \"\\ea25\";\r\n}\r\n\r\n.icon-gift-2::before {\r\n  content: \"\\ea26\";\r\n}\r\n\r\n.icon-globe-2::before {\r\n  content: \"\\ea27\";\r\n}\r\n\r\n.icon-headphones::before {\r\n  content: \"\\ea28\";\r\n}\r\n\r\n.icon-heart-2::before {\r\n  content: \"\\ea29\";\r\n}\r\n\r\n.icon-html5::before {\r\n  content: \"\\ea2a\";\r\n}\r\n\r\n.icon-image-02::before {\r\n  content: \"\\ea2b\";\r\n}\r\n\r\n.icon-istanbul::before {\r\n  content: \"\\ea2c\";\r\n}\r\n\r\n.icon-key-25::before {\r\n  content: \"\\ea2d\";\r\n}\r\n\r\n.icon-laptop::before {\r\n  content: \"\\ea2e\";\r\n}\r\n\r\n.icon-light-3::before {\r\n  content: \"\\ea2f\";\r\n}\r\n\r\n.icon-link-72::before {\r\n  content: \"\\ea30\";\r\n}\r\n\r\n.icon-lock-circle::before {\r\n  content: \"\\ea31\";\r\n}\r\n\r\n.icon-map-big::before {\r\n  content: \"\\ea32\";\r\n}\r\n\r\n.icon-minimal-down::before {\r\n  content: \"\\ea33\";\r\n}\r\n\r\n.icon-minimal-left::before {\r\n  content: \"\\ea34\";\r\n}\r\n\r\n.icon-minimal-right::before {\r\n  content: \"\\ea35\";\r\n}\r\n\r\n.icon-minimal-up::before {\r\n  content: \"\\ea36\";\r\n}\r\n\r\n.icon-mobile::before {\r\n  content: \"\\ea37\";\r\n}\r\n\r\n.icon-molecule-40::before {\r\n  content: \"\\ea38\";\r\n}\r\n\r\n.icon-money-coins::before {\r\n  content: \"\\ea39\";\r\n}\r\n\r\n.icon-notes::before {\r\n  content: \"\\ea3a\";\r\n}\r\n\r\n.icon-palette::before {\r\n  content: \"\\ea3b\";\r\n}\r\n\r\n.icon-paper::before {\r\n  content: \"\\ea3c\";\r\n}\r\n\r\n.icon-pencil::before {\r\n  content: \"\\ea3d\";\r\n}\r\n\r\n.icon-pin::before {\r\n  content: \"\\ea3e\";\r\n}\r\n\r\n.icon-planet::before {\r\n  content: \"\\ea3f\";\r\n}\r\n\r\n.icon-puzzle-10::before {\r\n  content: \"\\ea40\";\r\n}\r\n\r\n.icon-satisfied::before {\r\n  content: \"\\ea41\";\r\n}\r\n\r\n.icon-scissors::before {\r\n  content: \"\\ea42\";\r\n}\r\n\r\n.icon-send::before {\r\n  content: \"\\ea43\";\r\n}\r\n\r\n.icon-settings-gear-63::before {\r\n  content: \"\\ea44\";\r\n}\r\n\r\n.icon-settings::before {\r\n  content: \"\\ea45\";\r\n}\r\n\r\n.icon-simple-add::before {\r\n  content: \"\\ea46\";\r\n}\r\n\r\n.icon-simple-delete::before {\r\n  content: \"\\ea47\";\r\n}\r\n\r\n.icon-simple-remove::before {\r\n  content: \"\\ea48\";\r\n}\r\n\r\n.icon-single-02::before {\r\n  content: \"\\ea49\";\r\n}\r\n\r\n.icon-single-copy-04::before {\r\n  content: \"\\ea4a\";\r\n}\r\n\r\n.icon-sound-wave::before {\r\n  content: \"\\ea4b\";\r\n}\r\n\r\n.icon-spaceship::before {\r\n  content: \"\\ea4c\";\r\n}\r\n\r\n.icon-square-pin::before {\r\n  content: \"\\ea4d\";\r\n}\r\n\r\n.icon-support-17::before {\r\n  content: \"\\ea4e\";\r\n}\r\n\r\n.icon-tablet-2::before {\r\n  content: \"\\ea4f\";\r\n}\r\n\r\n.icon-tag::before {\r\n  content: \"\\ea50\";\r\n}\r\n\r\n.icon-tap-02::before {\r\n  content: \"\\ea51\";\r\n}\r\n\r\n.icon-tie-bow::before {\r\n  content: \"\\ea52\";\r\n}\r\n\r\n.icon-time-alarm::before {\r\n  content: \"\\ea53\";\r\n}\r\n\r\n.icon-trash-simple::before {\r\n  content: \"\\ea54\";\r\n}\r\n\r\n.icon-triangle-right-17::before {\r\n  content: \"\\ea55\";\r\n}\r\n\r\n.icon-trophy::before {\r\n  content: \"\\ea56\";\r\n}\r\n\r\n.icon-tv-2::before {\r\n  content: \"\\ea57\";\r\n}\r\n\r\n.icon-upload::before {\r\n  content: \"\\ea58\";\r\n}\r\n\r\n.icon-user-run::before {\r\n  content: \"\\ea59\";\r\n}\r\n\r\n.icon-vector::before {\r\n  content: \"\\ea5a\";\r\n}\r\n\r\n.icon-video-66::before {\r\n  content: \"\\ea5b\";\r\n}\r\n\r\n.icon-volume-98::before {\r\n  content: \"\\ea5c\";\r\n}\r\n\r\n.icon-wallet-43::before {\r\n  content: \"\\ea5d\";\r\n}\r\n\r\n.icon-watch-time::before {\r\n  content: \"\\ea5e\";\r\n}\r\n\r\n.icon-wifi::before {\r\n  content: \"\\ea5f\";\r\n}\r\n\r\n.icon-world::before {\r\n  content: \"\\ea60\";\r\n}\r\n\r\n.icon-zoom-split::before {\r\n  content: \"\\ea61\";\r\n}\r\n\r\n.icon-refresh-01::before {\r\n  content: \"\\ea62\";\r\n}\r\n\r\n.icon-refresh-02::before {\r\n  content: \"\\ea63\";\r\n}\r\n\r\n.icon-shape-star::before {\r\n  content: \"\\ea64\";\r\n}\r\n\r\n.icon-components::before {\r\n  content: \"\\ea65\";\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
